module.exports = __webpack_public_path__ + "img/event-resources.a8c64b55.svg";